<template>
  <div></div>
</template>

<script>
import { redirectToTrackerURLIfNeeded } from '@/utils/adjust_redirector'

export default class GroupChat extends Vue {
  created() {
    redirectToTrackerURLIfNeeded()
  }
}
</script>
